import { type QueryResolvers, AccessoryDrawerDisplay } from '../../../../generated/graphql'
import type { ApolloResolverContext } from '@edge/spark/io-apollo'
import { getAccessoryDrawerState } from '../../../../Stores'

export const accessoryDrawerStateResolver: QueryResolvers<ApolloResolverContext>['accessoryDrawerState'] = async () => {
    console.debug('io-dashboards accessoryDrawerStateResolver deprecated, use accessoryDrawer store')
    const state = getAccessoryDrawerState()
    return state ? AccessoryDrawerDisplay.WidgetConfig : null
}
